import React from "react";
import SkeletonElement from "../../Category/Shimmer/SkeletonElement";

const TableSkeletonElement = () => {
  return (
    <>
      <table
        id="table-skeleton"
        style={{
          width: "100%",
          tableLayout: "auto !important",
          whiteSpace: "nowrap",
        }}
        className="table tw-mt-3"
      >
        <thead
          style={{
            position: "sticky",
            top: "0px",
            // zIndex: "1",
            backgroundColor: "#f2f2f2",
            color: "#5c5f62",
          }}
        >
          <tr
            style={{
              background: "#f2f2f2",
              border: "1px solid #c9cccf",
              height: "43",
              fontFamily: "Noto Sans",
              fontWeight: 400,
              margin: "42px 0 12px",
              color: "#5c5f62",
            }}
          >
            <th
              className="border-0"
              width="200px"
              style={{
                position: "sticky",
                left: "0px",
                paddingLeft: "20px",
                backgroundColor: "rgb(246 246 246)",
                height: "43",
                fontFamily: "Noto Sans",
                fontWeight: 400,
                padding: "13px 31px 11px 20px",
                textTransform: "uppercase",
              }}
            >
              <SkeletonElement type="title" />
            </th>
            <th
              className="border-0"
              width="200px"
              style={{
                position: "sticky",
                left: "0px",
                paddingLeft: "20px",
                backgroundColor: "rgb(246 246 246)",
                height: "43",
                fontFamily: "Noto Sans",
                fontWeight: 400,
                padding: "13px 31px 11px 20px",
                textTransform: "uppercase",
              }}
            >
              <SkeletonElement type="title" />
            </th>
            <th
              className="border-0"
              width="200px"
              style={{
                position: "sticky",
                left: "0px",
                paddingLeft: "20px",
                backgroundColor: "rgb(246 246 246)",
                height: "43",
                fontFamily: "Noto Sans",
                fontWeight: 400,
                padding: "13px 31px 11px 20px",
                textTransform: "uppercase",
              }}
            >
              <SkeletonElement type="title" />
            </th>
            <th
              className="border-0"
              width="200px"
              style={{
                position: "sticky",
                left: "0px",
                paddingLeft: "20px",
                backgroundColor: "rgb(246 246 246)",
                height: "43",
                fontFamily: "Noto Sans",
                fontWeight: 400,
                padding: "13px 31px 11px 20px",
                textTransform: "uppercase",
              }}
            >
              <SkeletonElement type="title" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[111, 112, 113, 114, 115].map((product, singleProductindex) => {
            return (
              <tr key={singleProductindex} className="border-1">
                <th
                  width="30%"
                  className="align-middle border-1"
                  style={{
                    position: "sticky",
                    left: "0px",
                    // paddingLeft: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    padding: "13px 31px 11px 20px",
                  }}
                  title={""}
                >
                  <SkeletonElement type="text" />
                </th>
                <th
                  width="30%"
                  className="align-middle border-1"
                  style={{
                    position: "sticky",
                    left: "0px",
                    // paddingLeft: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    padding: "13px 31px 11px 20px",
                  }}
                  title={""}
                >
                  <SkeletonElement type="text" />
                </th>
                <th
                  width="30%"
                  className="align-middle border-1"
                  style={{
                    position: "sticky",
                    left: "0px",
                    // paddingLeft: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    padding: "13px 31px 11px 20px",
                  }}
                  title={""}
                >
                  <SkeletonElement type="text" />
                </th>
                <th
                  width="30%"
                  className="align-middle border-1"
                  style={{
                    position: "sticky",
                    left: "0px",
                    // paddingLeft: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    padding: "13px 31px 11px 20px",
                  }}
                  title={""}
                >
                  <SkeletonElement type="text" />
                </th>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};
export default TableSkeletonElement;
